import { useCxt } from "./StructureProvider";
import PropTypes from "prop-types";
import { useState } from "react";
import produce from "immer";
import Game from "./Game";
import {gameToWinRate} from "./elo"
import cloneDeep from "lodash/cloneDeep";

function isDone(score, goal) {
	console.log("[isDone]", score, goal);
	return Number(score[0]) === goal || Number(score[2]) === goal;
}

function Round({ stage, work, callBack}) {
	const {leagueStructure, updateLeagueStructure, leagueElo} = useCxt();
	const [gameN, setGameN] = useState(0);
	const games = leagueStructure[stage].works[work].games;
	const game = games[gameN];
	
	function playSet( game, score ) {
		const prob = gameToWinRate(game, leagueElo);
		const seed = Math.random();
		console.log("[playSet]", game, score, prob, seed);
		return seed < prob ? (((score[0] * 1) + 1) + ":" + score[2]) : (score[0] + ":" + ((score[2] * 1) + 1));
	}
	
	function playSetWrapper() {
		let score = game.score;
		console.log("[gameCallBack] playSets");
		score = playSet(game, score);

		updateLeagueStructure(produce(leagueStructure, (input) => {
			console.log(input, stage, work, gameN, score);
			input[stage].works[work].games[gameN].score = score;
		}));
		console.log("[gameCallBack] done");
	}
	
	function nextGame() {
		if(gameN + 1 < games.length) setGameN(gameN + 1);
		else {
			// Do Something
			console.log("[Round][gameCallBack] UnImplemented");
			callBack();
		}
	}
	
	function playGame( game ) {
		let score = game.score;
		const goal = (game.Bo+1)/2;
		console.log("[gameCallBack] playSets");
		let n = 0;
		while(!isDone(score, goal) && n++ < 10) score = playSet(game, score);
		
		console.log("[gameCallBack] done");
		return score;
	}
	
	function playGameWrapper() {
		const score = playGame(leagueStructure[stage].works[work].games[gameN]);

		updateLeagueStructure(produce(leagueStructure, (input) => {
			console.log(input, stage, work, gameN, score);
			input[stage].works[work].games[gameN].score = score;
		}));
	}
	// To Do: make button to pass the all stage.
	
	function playRound(tmpStructure) {
		const numberOfGames = leagueStructure[stage].works[work].games.length;
		for (let i = gameN; i < numberOfGames; i++) {
			const game = tmpStructure[stage].works[work].games[i];
			const score = playGame(game);
			tmpStructure[stage].works[work].games[i].score = score;
		}
	}
	
	function playRoundWrapper() {
		const tmpStructure = cloneDeep(leagueStructure);
		playRound(tmpStructure);
		updateLeagueStructure(tmpStructure);
		callBack();
	}
	
	return(
		<Game game={games[gameN]} playSet={playSetWrapper} playGame={playGameWrapper} nextGame={nextGame} playRound={playRoundWrapper}/>
	);
}

Round.propTypes = {
	stage: PropTypes.number,
	work: PropTypes.number,
	callBack: PropTypes.func,
}

export default Round;